// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_5aY","cls2":"SearchBox-cls2_s6X SearchBox-cls1_5aY"};